const newsKeys = {
	all: ['news']
};

export { newsKeys };
